import React from 'react';
import {connect} from 'react-redux';

import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import RteViewer          from 'app/components/common/rich-text/viewer';
import GrantSysDuck       from 'app/ducks/grants-system';
import helpers            from 'app/helpers/forms';
import paths              from 'app/paths';
import EntitiesSlx        from 'app/selectors/entities';

const {FieldTypes: FT} = helpers;



class PageGrantProgram extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onAfterPrint = this.onAfterPrint.bind(this);
  }

  componentDidMount() {
    window.addEventListener('afterprint', this.onAfterPrint);
    window.print();
  }

  componentWillUnmount() {
    window.removeEventListener('afterprint', this.onAfterPrint);
  }

  onAfterPrint() {
    // window.close();
  }
  
  renderFieldBody(field) {
    const bigSpace = [FT.TEXT_LONG, FT.ADDRESS].includes(field.type);
    if (bigSpace) return <div className="grant-prog-print-field-space large" />;

    const isSelect = [FT.SELECT, FT.MULTI_SELECT].includes(field.type);
    const isSingleSelect = field.type === FT.SELECT;
    if (isSelect) {
      const msg = isSingleSelect
        ? <p className="grant-prog-print-p">Please select <i>one</i> of the following:</p>
        : <p className="grant-prog-print-p">Please select <i>one or more</i> of the following:</p>;
      return (<>
        {msg}
        <ul className="grant-prog-print-field-list">
          {(field.opts?.options || []).map((opt, i) => {
            return <li key={i}>{opt}</li>;
          })}
        </ul>
      </>);
    }
    
    return <div className="grant-prog-print-field-space small" />;
  }

  render() {
    const {program, myApps, formMap} = this.props;
    const forms = (program.formIds || []).map(id => formMap[id]);

    if (!program) return <p>loading...</p>;
    const logoUrl = program.company?.logoUrl;

    return (
      <div className="grant-prog-print">
        <Meta title={program.title} />
        <Link href={paths.grantProgram(program.id)} className="blue-pink-hover grant-prog-print-back">Back</Link>
        <img src={logoUrl} alt={program.company.name} className="grant-prog-print-logo" />
        <h1 className="grant-prog-print-h1">{program.title}</h1>
        {!!program.landingText && <RteViewer className="grant-prog-print-md extra-space" md={program.landingText} />}
        {!!program.entryText && <RteViewer className="grant-prog-print-md extra-space" md={program.entryText} />}
        {forms.map((form, formIndex) => {
          return (
            <div key={form.id}>
              <h2 className="grant-prog-print-h2">{`Form #${formIndex+1}: ${form.title}`}</h2>
              {!!form.description && <RteViewer className="grant-prog-print-md" md={form.description} />}
              {form.formFields.map((field, fieldIndex) => {
                return (
                  <div key={field.id}>
                    <h3 className="grant-prog-print-h3">{`Question #${fieldIndex+1} ${field.isRequired ? '(required)' : ''}: ${field.title}`}</h3>
                    {!!field.description && <RteViewer className="grant-prog-print-md" md={field.description} />}
                    {this.renderFieldBody(field)}
                  </div>
                );
              })}
            </div>
          );
        })}
        {!!program.submitText && <RteViewer className="grant-prog-print-md extra-space" md={program.submitText} />}
      </div>
    );
  }

}

const stateToProps = (state) => ({
  formMap: EntitiesSlx.forms(state),
  program: GrantSysDuck.Slx.pathProgram(state),
  myApps: GrantSysDuck.Slx.myApps(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantProgram);
